import React, { createContext } from 'react';
import UserMenuItem from './UserMenuItem';
import useWindowSize from '../hooks/useWindowSize';

/**
 * Use this context for the open/close toggle so the user
 * has more flexibility with the structure of the children.
 */
export const UserMenuOpenToggleCtx = createContext({});

/**
 * There are two main ways to use the UserMenu component:
 * 1. Use 'items' array which will create UserMenuItem instances for each item.
 * 2. Use 'children', which should contain only UserMenuItem elements.
 */
export default ({ open = false, children, toggleOpen, items = [] }) => {
  let cls = 'no-print settings-drop menu-dropdown dropdown--dark transition';
  if (open) {
    cls += ' open';
  }

  return (
    <UserMenuOpenToggleCtx.Provider value={{ toggleOpen }}>
      <OverlayClickOutside toggle={toggleOpen} show={open} />
      <div className={cls} style={{ width: '180px', color: '#2d2d2d' }}>
        {items.length > 0 ? (
          <ul>
            {items.map((item, i) => (
              <UserMenuItem
                iconCls={item.iconCls}
                label={item.label}
                onClick={item.onClick}
                key={i}
                link={item.link}
              />
            ))}
          </ul>
        ) : (
          <ul>{children}</ul>
        )}
        <ul>
          <li className="label">        
            Innheimtukerfi
          </li>
          <li>
            <a href="/admin">Umsýsla</a>
          </li>
        </ul>
      </div>
    </UserMenuOpenToggleCtx.Provider>
  );
};

const OverlayClickOutside = ({ show, toggle }) => {
  const { height } = useWindowSize();
  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        height,
        width: '100%'
      }}
      onClick={toggle}
    />
  );
};
